import gql from 'graphql-tag'
import { EnumFields } from '..'

export const GenderFragment = gql`
  fragment Gender on persons_gender{
    ${EnumFields}
  }
`
